import Block from '@/components/Block'
import { Stack } from '@/components/Layout'
import Slider, { useSliderRef } from '@/components/Slider'
import Text from '@/components/Text'
import { coreLayoutContainer, coreLayoutSection } from '@/constants/measured-scope'
import { useAuth } from '@/context/auth'
import QuoteCard, { Props as QuoteCardProps } from '@/widgets/QuoteCard'
import { useMemo } from 'react'
import * as styles from './style'

export interface Props {
  quoteItems: Partial<QuoteCardProps>[]
  title?: string
  className?: string
}

const TestimonialBlock = ({ quoteItems: items, title }: Props): JSX.Element | null => {
  const { ref } = useSliderRef()

  const {
    state: { user },
  } = useAuth()

  const quoteItems = useMemo(() => items.map((item) => <QuoteCard {...item} />), [items])

  if (user || !items || !items.length) return null

  return (
    <Block className={coreLayoutSection}>
      <Stack className={`${coreLayoutContainer} py-sm py-md-gte-lg py-lg-gte-xxl`}>
        {title && (
          <Text size="lg" weight="lg" tag="h2" className="fs-xl-gte-desktop mb-md mb-lg-gte-sm mb-xl-gte-xxl ta-c">
            {title}
          </Text>
        )}
        <Slider ref={ref} items={quoteItems} spacing="sm" trackClasses={`${styles.grid}`} />
      </Stack>
    </Block>
  )
}

export default TestimonialBlock
